var phoenixTag = phoenixTag || {};

phoenixTag.packery = phoenixTag.packery || function ($) {
    function initPackery(callback) {

        if($('.packery-container').length) {
            $('.packery-container').packery({
                itemSelector: '.packery-item'
            });
        }
    }

    function constructFilter(callback) {
        if($('.filter-bar').length) {
            var container = $('.filter-bar');
            var select = $('select', container);
            var filterStructure = '<ul class="filter-construct"></ul>';
            $(filterStructure).prependTo(container);

            var filter = $('.filter-construct');
            var submit = $('.form-submit', container);

            var selectedArray = [];

            if($(select).val() != null) {
                selectedArray = $(select).val();
            }

            // Construct Filter
            $('option', select).each(function() {
                var current = $(this);
                var val = $(current).val();
                var string = $(current).html();
                var selected = '';
                var selectedClass = '';

                if($(current).is(':selected')) {
                    selected = 'selected';
                    selectedClass = 'active';
                }

                var liStructure = '<li class="' + selectedClass + '" data-target="' + val + '" selected="' + selected + '">' + string + '</li>';
                $(liStructure).appendTo(filter);
            });


            //Update select and apply filter
            $(filter).on('click', 'li', function() {

                var current = $(this);
                var currentTarget = $(current).data('target');
                var alreadySelected = $(current).hasClass('active');
                if (alreadySelected) {
                  var all = $('.filter-construct').find('[data-target="All"]');
                  $(all).click();
                }
                else if($(select).attr('multiple')) {

                    var arrayCheck = $.inArray(currentTarget.toString(), selectedArray);

                    if (arrayCheck == -1) {
                        selectedArray.push(currentTarget.toString());
                        $(current).addClass('active');

                    } else {
                        selectedArray.splice(arrayCheck, 1);
                        $(current).removeClass('active');
                    }

                    $(select).val(selectedArray);
                    $(select).trigger('change');
                    $(submit).trigger('click');

                } else {
                    $(select).val(currentTarget);
                    $(select).trigger('change');
                    $(submit).trigger('click');
                }
            });
        }
    }

    // public functions:
    return {
        initPackery: initPackery,
        constructFilter: constructFilter
    };
} (jQuery);
